import { HttpClient } from '@angular/common/http';
import { Component, OnInit, OnDestroy, ViewChild,Renderer2, ElementRef, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { GetUserQueryService } from 'src/app/services/get-user-query.service';
import { environment } from 'src/environments/environment';
import { ChangeDetectorRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { BrandService } from '../../services/brand.service';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-deductions',
  templateUrl: './deductions.component.html',
  styleUrls: ['./deductions.component.css'],
})
export class DeductionsComponent implements OnInit, OnDestroy {
  selected: string = 'deductions';
  id: string = '';
  mid!: number;
  unlimitedData: any;
  fixedData: any;
  queryData: any;
  dataATD: any;
  currentDate: any;
  name: any;
  email: any;
  mobile: any;
  submissionDate: any;
  file: any;
  successMessage: string = '';
  mobileView: boolean = false;
  unlimitTable: boolean = false;
  fixTable: boolean = false;
  loadingFiles: boolean = true;
  openDeduction: boolean = false;
  loading: boolean = false;
  docuSignUrl: string = '';
  modalTitle:string='';
  requestData:any;
  comments: string = "";
  payOutAmount?: number;
  deductionStatus:any;
  recurringDeduction:boolean=false;
  fixedDeduction:boolean=false;
  messageATD:string=`Your request has been sent to our payroll team for consideration. We will contact you to let you know the outcome.`
  reason:string='';
  address:string='';
  numberOfPeople: any=0;
  accommodation: string='';
  transport: string='';
  end_date:any;
  candidateName:string=''
  employeer:string='';
  validationMessage:string=''
  showSuccessMsg:boolean=false;
  viewData:any;
  reasonsOptions: string[]=['I am making my own arrangements.','I am leaving the country.','Other reason.']
  staticWarning:string="";
  minDate!: string;
  @ViewChild('staticBackdrop', { static: false }) modal!: ElementRef ;
  @ViewChild('AuthorityModal', { static: false }) modal2!: ElementRef ;
  @ViewChild('closeStaticModal', { static: true }) closeStaticModal!: ElementRef;
  payOutId:string='';
  comment:string='';
  payoutAmount1:number=0;
  payoutATD:boolean=false;
  accommodationOptions : string[]= ['Private Lease','Living With Friends'];
  brandLogo: string = 'assets/img/agrilabour-logo-01.png';
  brandLogoBase64: string = '';
  rcsaIconBase64: string = 'assets/assets/branding/healthpluspeople/rcsa.png';
  staffsureIconBase64: string = 'assets/assets/branding/healthpluspeople/staffsure.png';
  hireIconBase64: string = 'assets/assets/branding/healthpluspeople/iso.jpg';
  transportOptions : string[]=['Employer Provided Vehicle','Private Transport']
  healthPlusLogo: string = 'assets/assets/branding/healthpluspeople/logo.png';
  brandPhone:string='1300 247 823';
  brandEmail:string='info@agrilabour.com.au';
  brandName:string='';
  brandUrl:string='www.agrilabour.com.au';
  redirectUrl:string='';
  isHealthPlus: boolean = false;
  selectedCompanyName: string = '';
  showDocuSignInModal: boolean = false;
  docuSignLoading: boolean = false;
  sanitizedDocuSignUrl: SafeResourceUrl = '';
  iframeUrlCheckInterval: any;
  originalDocuSignUrl: string = '';
  docuSignTimeout: any;
  lastIframeUrl: string = '';
  // Back navigation blocker state
  backBlockerActive: boolean = false;
  onPopStateHandler: ((event: PopStateEvent) => void) | null = null;
  showExitConfirmation: boolean = false;

  toggleSidebar() {
    var menu = document.querySelector('.page-container');
    menu?.classList.toggle('sbar_collapsed');
  }

  constructor(
    private http: HttpClient,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private getUserQuery: GetUserQueryService,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2, private elementRef: ElementRef,
    @Inject(DOCUMENT) private document: Document,
    private brandService: BrandService,
    private sanitizer: DomSanitizer
  ) {
    const today = new Date();
    const minDate = new Date(today.getTime() + 28 * 24 * 60 * 60 * 1000);
    this.minDate = minDate?.toISOString().split('T')[0]; // format: YYYY-MM-DD
    this.getQuery();
    this.route.params.subscribe((params) => {
      if (window.screen.width <= 768) {
        this.toggleSidebar();
      }
    });
  }

  async ngOnInit(): Promise<void> {  
    this.redirectUrl = window.location.href;
    this.name = localStorage.getItem('name');
    this.email = localStorage.getItem('email');
    this.mobile = localStorage.getItem('mobile');
    
  try { 
    this.brandLogoBase64 = await this.loadLogoAsBase64(); // Keep using this for backward compatibility
    this.rcsaIconBase64 = await this.loadImageAsBase64(this.rcsaIconBase64);
    this.staffsureIconBase64 = await this.loadImageAsBase64(this.staffsureIconBase64);
    this.hireIconBase64 = await this.loadImageAsBase64(this.hireIconBase64);
  } catch (error) {
    // console.error('Failed to load images:', error);
  }
  }

  getQuery() {
    this.getUserQuery.getUserQuery().subscribe((res: any) => {
        this.queryData = res.data;
        const allComplete = this.queryData?.every((item: { deductionStatus: string }) => item.deductionStatus === 'Complete');
        localStorage.setItem('deductionStatus', allComplete ? 'Complete' : 'Incomplete');
        this.deductionStatus=localStorage.getItem('deductionStatus');
        this.loadingFiles = false;
      },
      (error) => {
        // console.error('Error fetching query data:');
        this.loadingFiles = false;
      }
    );
  }

  onKeyDown(event: KeyboardEvent) {
    if (['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'].indexOf(event.key) !== -1) {
      event.preventDefault();
    }
  }

  viewDeduction(item: any): void {
    this.viewData=item;
    this.successMessage = '';
    this.loadingFiles = true;
    this.mid = item.mid;
    this.employeer=item.companyName;
    this.brandName=item.companyName;
    this.candidateName= item.name_first+" "+item.name_last;
    // Store the selected company name for letterhead logic
    this.selectedCompanyName = item.companyName || '';
    // First API call
    const apiUrl = `${environment.apiConfig.uri}/AstutePayAdvice/GetDeduction/${this.mid}`;
    this.http.get(apiUrl).subscribe(
      (response: any) => {
        this.unlimitedData = response.data.unlimited;
        this.fixedData = response.data.fixed_amount;
        const secondUrl = `${environment.apiConfig.uri}/Candidate/GetDeductionMetaData/${this.mid}`;
        this.http.get(secondUrl).subscribe((metaDataResponse: any) => {
          const mdata = metaDataResponse.data;
          const metaData = mdata.map((item: any) => {
            return {
              ...item, // Keep all existing properties
              amount: parseFloat(item.amount).toFixed(2),
              date_from: item.date_from?.split('T')[0],
            };
          });

          // Iterate through unlimitedData and metaData to update fileId
          this.unlimitedData.forEach((unlimitedItem: any) => {
            metaData.forEach((metaItem: any) => {
              if (
                unlimitedItem.pdid == metaItem.pdid && unlimitedItem.deductionId == metaItem.deductionId &&
                parseFloat(unlimitedItem.amount).toFixed(2) ==
                  parseFloat(metaItem.amount).toFixed(2) &&
                unlimitedItem.date_from == metaItem.date_from
              ) {
                unlimitedItem.isSigned = metaItem.isSigned;
                unlimitedItem.fileId = metaItem.fileId;
                unlimitedItem.status = metaItem.status;
                unlimitedItem.envelopeId = metaItem.envelopeId;
              }
            });
          });
          this.fixedData.forEach((fixedItem: any) => {
            metaData.forEach((metaItem: any) => {
              if (
                fixedItem.pdid == metaItem.pdid && fixedItem.deductionId == metaItem.deductionId &&
                parseFloat(fixedItem.amount).toFixed(2) ==
                  parseFloat(metaItem.amount).toFixed(2) &&
                fixedItem.date_from == metaItem.date_from
              ) {
                fixedItem.isSigned = metaItem.isSigned;
                fixedItem.fileId = metaItem.fileId;
                fixedItem.status = metaItem.status;
                fixedItem.envelopeId = metaItem.envelopeId;
              }
            });
          });
          this.loadingFiles = false;
          this.openDeduction = true;
        });
      },
      (error) => {
        // console.error('Error fetching file stream:', error);
        this.loadingFiles = false;
      }
    );
  }

  resetForm() {
    this.reason = '';
    this.validationMessage = '';
    this.showSuccessMsg = false;
    this.end_date = '';
    this.comments = '';
    this.payOutAmount = undefined;
}

stopDeduction(data: any) {
    this.resetForm();
    this.recurringDeduction = true;
    this.fixedDeduction = false;
    this.requestData = data;
    this.staticWarning=`You must provide 28 days notice to stop a deduction.`
    this.modalTitle = 'Request to Stop Deduction';
}

payOutDeduction(data: any) {
    this.resetForm();
    this.fixedDeduction = true;
    this.staticWarning=''
    this.recurringDeduction = false;
    this.requestData = data;
    this.modalTitle = 'Request to Pay Out Deduction';
}
  
submitRequest(comments: string, payOutAmount: any, end_date: any, reason: string) {
  this.validationMessage = '';
  this.payoutAmount1 = payOutAmount;
  this.comment=comments;
  const pdid = this.requestData.pdid;
  const uid = this.requestData.uid;
  if (this.recurringDeduction) {
      if (!end_date) {
          this.validationMessage = 'End Date is required for recurring deductions.';
          return;
      } else if (!reason) {
          this.validationMessage = 'Reason is required for recurring deductions.';
          return;
      } else if (!comments) {
          this.validationMessage = 'Comments are required for recurring deductions.';
          return;
      }
  } else if (this.fixedDeduction) {
      if (!payOutAmount || payOutAmount <= 0 || isNaN(payOutAmount)) {
          this.validationMessage = 'Pay Out Amount is required and must be greater than 0.';
          return;
      }
  }
  // Prepare the request data object
  const reqData: any = {
      uid: uid,
      pdid: pdid,
      name: this.requestData.name,
      candidateName: this.candidateName,
      employeer: this.employeer,
      note: comments,
      limit_type: this.requestData.limit_type,
      isAstute: this.requestData.isAstute,
      isPayOut: true
  };
  // Add recurring deduction-specific fields if applicable
  if (this.recurringDeduction) {
      reqData.date_to = end_date;
      reqData.reason = reason;
  }
  // Add fixed deduction-specific fields if applicable
  if (this.fixedDeduction) {
      reqData.amount_taken = payOutAmount;
  }
  // Optional fields for number of people, accommodation, and transport
  if (this.numberOfPeople) {
      reqData.numberOfPeople = this.numberOfPeople;
  }
  if (this.accommodation) {
      reqData.accommodation = this.accommodation;
  }
  if (this.transport) {
      reqData.transport = this.transport;
  }
  if (this.address) {
    reqData.address = this.address;
}
  const reqUrl = `${environment.apiConfig.uri}/AstutePayAdvice/DeductionStop`;
  this.loading = true;
  this.http.post(reqUrl, reqData).subscribe(
    (res: any) => {
      try {
          this.showSuccessMsg = true;
          this.loading = false;
          this.staticWarning = '';
          this.successMessage = '';
          this.payOutId = res.data;
          this.currentDate = new Date();
          if (this.fixedDeduction) {
              this.payoutATD = true;
              this.comment = comments;
              this.payoutAmount1 = payOutAmount;
              this.successMessage = '';
              this.currentDate = new Date();
              this.dataATD = [this.requestData];
              this.closeModal('staticBackdrop');
              this.openModal('AuthorityModal');
          }
          this.viewDeduction(this.viewData);
      } catch (error: any) {
          this.loading = false;
          this.validationMessage = error.message;
          this.showSuccessMsg = true;
      }
      // Clear form fields after successful submission
      this.reason = "";
      this.end_date = "";
      this.comments = "";
      this.payOutAmount = 0;
      this.numberOfPeople = null;
      this.address='';
      this.accommodation = "";
      this.transport = "";
    },
    (error) => {
      // Handle HTTP error response
      this.loading = false;
      this.validationMessage = error?.error?.message || error?.message || 'An error occurred while processing your request. Please try again or contact support.';
      console.error('Pay out request failed:', error);
    }
  );
}

  private openModal(modalId: string) {
    const modal = this.elementRef.nativeElement.querySelector(`#${modalId}`);
    if (modal) {
      // Add Bootstrap modal classes and attributes
      this.renderer.addClass(modal, 'show');
      this.renderer.setStyle(modal, 'display', 'block');
      this.renderer.setAttribute(modal, 'aria-hidden', 'false');
      this.renderer.setAttribute(modal, 'aria-modal', 'true');
      this.renderer.setAttribute(modal, 'role', 'dialog');
      // Ensure modal backdrop is added
      const backdrop = this.renderer.createElement('div');
      this.renderer.addClass(backdrop, 'modal-backdrop');
      this.renderer.addClass(backdrop, 'fade');
      this.renderer.addClass(backdrop, 'show');
      this.renderer.appendChild(document.body, backdrop);
      // Add modal-open class and adjust body styles
      this.renderer.addClass(document.body, 'modal-open');
      this.renderer.setStyle(document.body, 'overflow', 'hidden');
      this.renderer.setStyle(document.body, 'padding-right', '0');
    }
  }

  private closeModal(modalId: string) {
    const modal = this.elementRef.nativeElement.querySelector(`#${modalId}`);
    if (modal) {
      // Remove Bootstrap modal classes and attributes
      this.renderer.removeClass(modal, 'show');
      this.renderer.setStyle(modal, 'display', 'none');
      this.renderer.setAttribute(modal, 'aria-hidden', 'true');
      this.renderer.removeAttribute(modal, 'aria-modal');
      this.renderer.removeAttribute(modal, 'role');
        // Remove the modal backdrop if it exists
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
          backdrop.parentNode?.removeChild(backdrop);
        }
  
        // Remove modal-open class and reset body styles
        this.renderer.removeClass(document.body, 'modal-open');
        this.renderer.setStyle(document.body, 'overflow', '');
        // this.renderer.setStyle(document.body, 'padding-right', '');
    }
  }
  
  closeAuthorityModal(data:any) {
    this.closeModal(data);
    this.loading = false;
    const hadSuccess = !!this.successMessage;
    this.validationMessage = '';
    this.successMessage = '';
    if (hadSuccess) {
      this.openDeduction = false;
    }
  }

  closeSidebar() {
    var menu = document.querySelector('.page-container');
    menu?.classList.add('sbar_collapsed');
  }

  ngAfterViewInit() {
    if (window.screen.width <= 768) {
      this.mobileView = true;
      this.cdr.detectChanges();
    }
  }

  ngOnDestroy() {
    // Clean up iframe URL monitoring and timeout
    this.stopIframeUrlMonitoring();
    this.clearDocuSignTimeout();
    // Ensure back-button blocker is removed
    this.disableBackNavigationBlocker();
    // Restore normal page navigation
    this.restorePageNavigation();
  }

  openDocuSign() {
    if (this.showDocuSignInModal) {
      // console.log('DocuSign modal already open, ignoring duplicate call');
      return;
    }
    
    // Validate DocuSign URL exists
    if (!this.docuSignUrl || this.docuSignUrl.trim() === '') {
      console.error('DocuSign URL is empty or invalid');
      return;
    }
    
    // Store original URL for comparison
    this.originalDocuSignUrl = this.docuSignUrl;
    
    // Sanitize the URL to make it trusted
    this.sanitizedDocuSignUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.docuSignUrl);
    
    this.showDocuSignInModal = true;
    this.docuSignLoading = true;
    
    // Clear any existing monitoring to prevent conflicts
    this.stopIframeUrlMonitoring();
    this.clearDocuSignTimeout();
    
    // Enable browser back-button blocker while DocuSign is open
    this.enableBackNavigationBlocker();
    
    // Prevent page reload by blocking navigation events
    this.preventPageReload();
    
    this.setupDocuSignListener();
    
    // Start URL monitoring after a longer delay to let iframe load properly
    setTimeout(() => {
      // console.log('Starting iframe URL monitoring after delay');
      this.startIframeUrlMonitoring();
    }, 5000); // 5 second delay to ensure iframe is fully loaded
    
    // Simple timeout to hide loading spinner after iframe loads
    setTimeout(() => {
      if (this.showDocuSignInModal) { // Only hide loading if modal is still open
        this.docuSignLoading = false;
      }
    }, 1000); // 1 second timeout - just to hide loading spinner
     
    // Fallback timeout - close modal after 10 minutes if no completion detected
    this.docuSignTimeout = setTimeout(() => {
      if (this.showDocuSignInModal) {
        // console.log('DocuSign timeout reached - closing modal');
        this.onDocuSignProcessComplete();
      }
    }, 600000); // 10 minutes timeout
  }

  setupDocuSignListener() {
    // Listen for postMessage from DocuSign iframe
    window.addEventListener('message', (event) => {
      // console.log('Received postMessage:', event.data, 'from origin:', event.origin);
      
      // Check for completion messages from any origin (not just DocuSign)
      if (event.data && (
        // String messages
        event.data === 'docusign-complete' ||
        event.data === 'signing_complete' ||
        event.data === 'signing-complete' ||
        event.data === 'envelope_complete' ||
        event.data === 'envelope-complete' ||
        event.data === 'complete' ||
        event.data === 'thank' ||
        (typeof event.data === 'string' && event.data.includes('complete')) ||
        (typeof event.data === 'string' && event.data.includes('thank')) ||
        // Object messages
        (typeof event.data === 'object' && (
          event.data.type === 'docusign-complete' || 
          event.data.event === 'signing_complete' ||
          event.data.event === 'signing_completed' ||
          event.data.event === 'envelope_complete' ||
          event.data.event === 'envelope_completed' ||
          event.data.status === 'completed' ||
          event.data.message === 'signing_complete' ||
          event.data.eventType === 'signing_complete' ||
          event.data.eventType === 'envelope_complete'
        ))
      )) {
        // console.log('✅ DocuSign completion detected via postMessage - closing modal');
        this.onDocuSignComplete();
      }
    });
  }

  onDocuSignComplete() {
    // console.log('DocuSign signing completed');
    this.stopIframeUrlMonitoring();
    this.showDocuSignInModal = false;
    this.docuSignLoading = false;
    this.closeAuthorityModal('AuthorityModal');
    // Disable back-button blocker after completion/closure
    this.disableBackNavigationBlocker();
    // Restore normal page navigation
    this.restorePageNavigation();
    // Refresh deductions data
    this.viewDeduction(this.viewData);
  }

  onDocuSignIframeLoad() {
    // console.log('DocuSign iframe loaded successfully');
    this.docuSignLoading = false;
  }

  onDocuSignIframeError() {
    // console.error('DocuSign iframe failed to load');
    this.docuSignLoading = false;
  }

  startIframeUrlMonitoring() {
    // console.log('Starting iframe URL monitoring');
    
    // Check iframe URL every 2 seconds
    this.iframeUrlCheckInterval = setInterval(() => {
      this.checkIframeUrlChange();
    }, 2000);
  }

  checkIframeUrlChange() {
    try {
      const iframe = document.querySelector('.docuSign-iframe') as HTMLIFrameElement;
      if (iframe && iframe.contentWindow) {
        try {
          const currentUrl = iframe.contentWindow.location.href;          
          // Skip if URL is empty or still loading
          if (!currentUrl || currentUrl === 'about:blank' || currentUrl === '') {
            // console.log('Iframe still loading, skipping check');
            return;
          }
          
          // Skip if URL is the same as original DocuSign URL (still on DocuSign)
          if (currentUrl === this.originalDocuSignUrl) {
            // console.log('Still on original DocuSign URL, continuing...');
            return;
          }
          
          // FIRST: Check if URL is allowed (only DocuSign URLs)
          if (!this.isAllowedDocuSignUrl(currentUrl)) {
            // console.log('❌ URL is NOT a valid DocuSign URL - closing modal immediately');
            this.onDocuSignProcessComplete();
            return;
          }
          
          // SECOND: Always check current URL for completion patterns (regardless of URL change)
          if (this.isSigningComplete(currentUrl)) {
            // console.log('✅ Signing process completed - closing modal immediately');
            this.onDocuSignProcessComplete();
            return;
          }
          
          // Store the last URL for comparison
          if (this.lastIframeUrl === '') {
            this.lastIframeUrl = currentUrl;
            return;
          }
          
          // Check if URL has changed
          if (currentUrl !== this.lastIframeUrl) {
            
            // Check for completion patterns on URL change
            if (this.isSigningComplete(currentUrl)) {
              this.onDocuSignProcessComplete();
            } else {
              // Update last URL and continue monitoring
              this.lastIframeUrl = currentUrl;
            }
          }
        } catch (error) {
          // Cross-origin error is expected, this means iframe is still on DocuSign domain
        }
      }
    } catch (error) {
      // console.log('Error checking iframe URL:', error);
    }
  }

  isAllowedDocuSignUrl(url: string): boolean {
    // Allow only DocuSign URLs like https://demo.docusign.net/Signing/MTRed
    const allowedDomains = [
      'docusign.net',
      'docusign.com',
      'demo.docusign.net',
      'demo.docusign.com'
    ];
    
    const isDocuSignDomain = allowedDomains.some(domain => url.includes(domain));
    // console.log('🔍 URL validation - URL:', url, 'Is DocuSign domain:', isDocuSignDomain);
    
    return isDocuSignDomain;
  }

  isSigningComplete(url: string): boolean {
    // console.log('🔍 Completion check - Current URL:', url);
    // console.log('🔍 Expected redirect URL:', this.redirectUrl);
    
    // HIGHEST PRIORITY: Check if URL is NOT a DocuSign domain (redirected away)
    const isNotDocuSignDomain = !url.includes('docusign.net') && !url.includes('docusign.com');
    if (isNotDocuSignDomain) {
      // console.log('✅ URL is NOT on DocuSign domain - signing complete!');
      return true;
    }
    
    // SECOND PRIORITY: Check for specific DocuSign completion patterns
    if (url.includes('event=signing_complete')) {
      // console.log('✅ URL contains event=signing_complete - signing complete!');
      return true;
    }
    
    if (url.includes('thank')) {
      // console.log('✅ URL contains "thank" - signing complete!');
      return true;
    }
    
    // THIRD PRIORITY: Check if URL matches the redirectUrl exactly
    if (this.redirectUrl && url === this.redirectUrl) {
      // console.log('✅ Exact match with redirectUrl - signing complete!');
      return true;
    }
    
    // FOURTH PRIORITY: Check if URL contains the redirectUrl (partial match)
    if (this.redirectUrl && url.includes(this.redirectUrl)) {
      // console.log('✅ Partial match with redirectUrl - signing complete!');
      return true;
    }
    
    // Fallback: Check for other completion patterns
    const completionPatterns = [
      'complete',
      'success', 
      'finished',
      'done',
      'signing-complete',
      'envelope-complete',
      'signing-completed',
      'envelope-completed',
      'signed',
      'completed',
      'thank-you',
      'success-page',
      'completion',
      'finish'
    ];
    
    // Check if URL contains any completion patterns
    const hasCompletionPattern = completionPatterns.some(pattern => 
      url.toLowerCase().includes(pattern.toLowerCase())
    );
    
    // Check for specific completion URLs
    const isCompletionUrl = url.includes('/complete') || 
                          url.includes('/success') || 
                          url.includes('/thank') ||
                          url.includes('/finish') ||
                          url.includes('/done');
    
    // console.log('Has completion pattern:', hasCompletionPattern);
    // console.log('Is not DocuSign domain:', isNotDocuSignDomain);
    // console.log('Is completion URL:', isCompletionUrl);
    
    return hasCompletionPattern || isNotDocuSignDomain || isCompletionUrl;
  }

  onDocuSignProcessComplete() {
    // console.log('DocuSign process completed - closing modal');
    this.stopIframeUrlMonitoring();
    this.clearDocuSignTimeout();
    this.onDocuSignComplete();
  }

  stopIframeUrlMonitoring() {
    if (this.iframeUrlCheckInterval) {
      clearInterval(this.iframeUrlCheckInterval);
      this.iframeUrlCheckInterval = null;
      // console.log('Stopped iframe URL monitoring');
    }
  }

  clearDocuSignTimeout() {
    if (this.docuSignTimeout) {
      clearTimeout(this.docuSignTimeout);
      this.docuSignTimeout = null;
      // console.log('Cleared DocuSign timeout');
    }
  }

  private enableBackNavigationBlocker() {
    if (this.backBlockerActive) {
      return;
    }
    this.backBlockerActive = true;
    
    // Add a history entry to prevent back navigation
    try {
      history.pushState({ docuSignModal: true }, '', window.location.href);
    } catch (error) {
      // Fallback if history manipulation fails
    }
    
    this.onPopStateHandler = (event: PopStateEvent) => {
      // If DocuSign modal is active, intercept back navigation
      if (this.showDocuSignInModal) {
        // Show custom confirmation modal instead of browser confirm
        this.showExitConfirmation = true;
        // Reinstate current state to effectively cancel back navigation
        try {
          history.pushState({ docuSignModal: true }, '', window.location.href);
        } catch (error) {
          // Fallback if history manipulation fails
        }
      }
    };
    window.addEventListener('popstate', this.onPopStateHandler);
  }

  private disableBackNavigationBlocker() {
    if (!this.backBlockerActive) {
      return;
    }
    if (this.onPopStateHandler) {
      window.removeEventListener('popstate', this.onPopStateHandler);
      this.onPopStateHandler = null;
    }
    this.backBlockerActive = false;
  }

  private preventPageReload() {
    // Handle beforeunload events gracefully
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (this.showDocuSignInModal) {
        // Close the modal when user tries to leave
        this.onDocuSignComplete();
        // Allow the navigation to proceed
        return undefined;
      }
      return undefined;
    };
    
    window.addEventListener('beforeunload', handleBeforeUnload);
    
    // Store the handler for cleanup
    (this as any).preventReloadHandler = handleBeforeUnload;
  }

  private restorePageNavigation() {
    // Remove the beforeunload prevention
    if ((this as any).preventReloadHandler) {
      window.removeEventListener('beforeunload', (this as any).preventReloadHandler);
      (this as any).preventReloadHandler = null;
    }
  }

  // Handle exit confirmation modal
  confirmExit() {
    this.showExitConfirmation = false;
    this.onDocuSignComplete();
  }

  cancelExit() {
    this.showExitConfirmation = false;
  }

  createDeductionSlip(data: any) {
    if(data.batchId){
       // Filter fixedData and unlimitedData to find entries with the same batchId
    const fixedDataMatches = this.fixedData.filter((item: { batchId: any; }) => item.batchId === data.batchId);
    const unlimitedDataMatches = this.unlimitedData.filter((item: { batchId: any; }) => item.batchId === data.batchId);
    // Combine the matching entries
    this.dataATD = [...fixedDataMatches, ...unlimitedDataMatches];
    }
    else{
      this.dataATD = [data];
    }
    this.successMessage = '';
    this.currentDate = new Date();
  }

  async submitATD() {
      // Don't clear docuSignUrl here - it will be set after PDF generation
      this.submissionDate = new Date().toLocaleString();
      try {
          this.loading = true;
          // Ensure logo is loaded
          if (!this.brandLogoBase64) {
              try {
                  this.brandLogoBase64 = await this.loadLogoAsBase64();
              } catch (error) {
                  // console.error('Failed to load logo:', error);
              }
          }
          
          // Create document definition for pdfMake
          let docDefinition;
          // Check if brand is Health+People based on selected company name
          if (this.selectedCompanyName && this.selectedCompanyName.toLowerCase().includes('health')) {
            try {
              this.brandLogo = this.healthPlusLogo;
              this.brandLogoBase64 = await this.loadImageAsBase64(this.brandLogo);
              
              // Load footer icons as base64 with error handling
              const iconPromises = [];
              
                  if (!this.rcsaIconBase64.startsWith('data:')) {
                iconPromises.push(
                  this.loadImageAsBase64('assets/assets/branding/healthpluspeople/rcsa.png')
                    .then(data => this.rcsaIconBase64 = data)
                    .catch(error => console.warn('Failed to load RCSA icon:', error))
                );
              }
              
                  if (!this.staffsureIconBase64.startsWith('data:')) {
                iconPromises.push(
                  this.loadImageAsBase64('assets/assets/branding/healthpluspeople/staffsure.png')
                    .then(data => this.staffsureIconBase64 = data)
                    .catch(error => console.warn('Failed to load StaffSure icon:', error))
                );
              }
              
                  if (!this.hireIconBase64.startsWith('data:')) {
                iconPromises.push(
                  this.loadImageAsBase64('assets/assets/branding/healthpluspeople/iso.jpg')
                    .then(data => this.hireIconBase64 = data)
                    .catch(error => console.warn('Failed to load Hire icon:', error))
                );
              }
              
              // Wait for all icons to load (or fail gracefully)
              await Promise.all(iconPromises.map(promise => promise.catch(() => null)));
              
              } catch (error) {
              console.error('Failed to load Health Plus People branding:', error);
              // Use text instead of images when assets fail
              this.brandLogoBase64 = '';
              this.rcsaIconBase64 = '';
              this.staffsureIconBase64 = '';
              this.hireIconBase64 = '';
              }
              
              // Health+People specific layout
              docDefinition = {
                  pageSize: 'A4',
                  pageOrientation: 'portrait',
                  pageMargins: [40, 40, 40, 40],
                  defaultStyle: {
                      font: 'Roboto'
                  },
                  images: {
                      ...(this.brandLogoBase64 && this.brandLogoBase64.startsWith('data:') ? { 'brandLogo': this.brandLogoBase64 } : {}),
                      ...(this.rcsaIconBase64 && this.rcsaIconBase64.startsWith('data:') ? { 'rcsaIcon': this.rcsaIconBase64 } : {}),
                      ...(this.staffsureIconBase64 && this.staffsureIconBase64.startsWith('data:') ? { 'staffsureIcon': this.staffsureIconBase64 } : {}),
                      ...(this.hireIconBase64 && this.hireIconBase64.startsWith('data:') ? { 'hireIcon': this.hireIconBase64 } : {})
                  },
                  content: [
                      // Header - only logo on right
                      {
                          columns: [
                              { width: '*', text: '' }, // Empty space on left
                              this.brandLogoBase64 && this.brandLogoBase64.startsWith('data:') ? {
                                  image: 'brandLogo',
                                  width: 230,
                                  alignment: 'right'
                              } : {
                                  text: this.brandName,
                                  width: 150,
                                  alignment: 'right',
                                  bold: true
                              }
                          ]
                      },
                      { text: 'AUTHORITY FOR PAYROLL DEDUCTIONS', style: 'header', margin: [0, 20, 0, 10] },
                      {
                          text: `I ${this.name} authorize ${this.brandName} Pty Ltd to make deductions to my pay, as specified in the table below.`, 
                          margin: [0, 0, 0, 20]
                      },
                      // Table content remains the same
                      {
                          table: {
                              headerRows: 1,
                              widths: this.fixedDeduction ? 
                                  ['*', '*', '*'] :  // 3 columns for fixed deduction
                                  ['*', '*', '*', '*', '*'],  // 5 columns for non-fixed deduction
                              body: [
                                  this.fixedDeduction ?
                                      ['Description', 'Pay-Out Amount', 'Comments'] :
                                      ['Description', 'Amount Each Pay', 'Total Amount', 'Commencing', 'Notes'],
                                  ...this.dataATD.map((item: any) => (
                                      this.fixedDeduction ?
                                      [
                                          item.name || '-',
                                          `${this.payoutAmount1 ? Number(this.payoutAmount1).toFixed(2) : '-'}`,
                                          `${this.comment ? this.comment : '-'}`
                                      ] : [
                                          item.name || '-',
                                          `${item.amount ? Number(item.amount).toFixed(2) : '-'}`,
                                          `${item.total_paid ? Number(item.total_paid).toFixed(2) : '-'}`,
                                          item.date_from ? new Date(item.date_from).toLocaleDateString() : '-',
                                          item.note || '-'
                                      ]
                                  ))
                              ]
                          }
                      },
                      {
                          text: '\n\n\n\n\n'
                      },
                      {
                          columns: [
                              {
                                  width: '*',
                                  text: [
                                      { text: 'Signature:', bold: true },
                                      { text: '\n\n' },
                                      { text: `Date: ${new Date().toLocaleDateString()}`, bold: true }
                                  ]
                              }
                          ]
                      },
                      {
                          text: '\n'
                      },
                  ],
                  // Footer definition as a direct property of docDefinition
                                // Footer definition as a direct property of docDefinition
                footer: () => {
                    return {
                        table: {
                            widths: ['*', 'auto'],
                            body: [
                                [
                                    // Left side - contact info
                                    {
                                        stack: [
                                            { text: 'A G01N 527 Gregory Terrace, Fortitude Valley QLD 4006', style: 'contactInfo' },
                                            { text: 'T +617 4638 0071 | E info@healthpluspeople.com.au', style: 'contactInfo' },
                                            { text: 'HEALTHPLUSPEOPLE.COM.AU', style: 'contactInfoUrl'}
                                        ],
                                        border: [false, false, false, false],
                                        margin: [30, 5, 0, 15],
                                        alignment: 'left'
                                    },
                                    // Right side - icons
                                    {
                                        columns: [
                                            // RCSA icon
                                            this.rcsaIconBase64 && this.rcsaIconBase64.startsWith('data:') ? {
                                                image: 'rcsaIcon',
                                                width: 60,
                                                height: 25,
                                                margin: [0, 0, 5, 0]
                                            } : { 
                                                text: 'RCSA', 
                                                fontSize: 8,
                                                color: '#818285',
                                                width: 60,
                                                margin: [0, 0, 5, 0]
                                            },
                                            
                                            // StaffSure icon
                                            this.staffsureIconBase64 && this.staffsureIconBase64.startsWith('data:') ? {
                                                image: 'staffsureIcon',
                                                width: 60,
                                                height: 25,
                                                margin: [0, 0, 5, 0]
                                            } : { 
                                                text: 'StaffSure', 
                                                fontSize: 8,
                                                color: '#818285',
                                                width: 60,
                                                margin: [0, 0, 5, 0]
                                            },
                                            
                                            // Hire/ISO icon
                                            this.hireIconBase64 && this.hireIconBase64.startsWith('data:') ? {
                                                image: 'hireIcon',
                                                width: 25,
                                                height: 25,
                                                margin: [0, 0, 0, 0]
                                            } : { 
                                                text: 'ISO', 
                                                fontSize: 8,
                                                color: '#818285',
                                                width: 25,
                                                margin: [0, 0, 0, 0]
                                            }
                                        ],
                                        border: [false, false, false, false],
                                        alignment: 'right',
                                        margin: [0, 5, 30, 5]
                                    }
                                ]
                            ]
                        },
                        layout: 'noBorders',
                        margin: [0, 0, 0, 15]
                    };
                },
                  styles: {
                      header: {
                          fontSize: 18,
                          bold: true,
                          alignment: 'center'
                      },
                      contactInfo: {
                          fontSize: 7,
                          color: '#818285',
                          lineHeight: 1.0
                      },
                      contactInfoUrl: {
                          fontSize: 7,
                          color: '#5B5CAF',
                          bold: true,
                          lineHeight: 1.0
                      }
                  }
              };
          } else {
              // Original Agrilabour layout
              docDefinition = {
                  pageSize: 'A4',
                  pageOrientation: 'portrait',
                  pageMargins: [40, 40, 40, 40],
                  defaultStyle: {
                      font: 'Roboto'
                  },
                  images: {
                      // Only add images that are valid data URLs and properly formatted
                      ...(this.brandLogoBase64 && this.brandLogoBase64.startsWith('data:') ? { 'brandLogo': this.brandLogoBase64 } : {}),
                  },
                  content: [
                      {
                          columns: [
                              this.brandLogoBase64 && this.brandLogoBase64.startsWith('data:') ? {
                                  image: 'brandLogo',
                                  width: 150
                              } : {
                                  text: this.brandName,
                                  width: 150,
                                  bold: true
                              },
                              {
                                  text: [
                                      { text: this.brandPhone + '\n', style: 'contactInfo' },
                                      { text: 'G01N 527 Gregory Terrace,\n', style: 'contactInfo' },
                                      { text: 'Fortitude Valley QLD 4006\n', style: 'contactInfo' },
                                      { text: 'ABN 23 142 526 216\n', style: 'contactInfo' },
                                      { text: 'ACN 142 526 216\n', style: 'contactInfo' },
                                      { text: this.brandUrl + '\n', style: 'contactInfo' }
                                  ],
                                  alignment: 'right'
                              }
                          ]
                      },
                      { text: 'AUTHORITY FOR PAYROLL DEDUCTIONS', style: 'header', margin: [0, 20, 0, 10] },
                      {
                          text: `I ${this.name} authorize ${this.brandName} Pty Ltd to make deductions to my pay, as specified in the table below.`,
                          margin: [0, 0, 0, 20]
                      },
                      {
                          table: {
                              headerRows: 1,
                              widths: this.fixedDeduction ? 
                                  ['*', '*', '*'] :  // 3 columns for fixed deduction
                                  ['*', '*', '*', '*', '*'],  // 5 columns for non-fixed deduction
                              body: [
                                  this.fixedDeduction ?
                                      ['Description', 'Pay-Out Amount', 'Comments'] :
                                      ['Description', 'Amount Each Pay', 'Total Amount', 'Commencing', 'Notes'],
                                  ...this.dataATD.map((item: any) => (
                                      this.fixedDeduction ?
                                      [
                                          item.name || '-',
                                          `$${this.payoutAmount1 ? Number(this.payoutAmount1).toFixed(2) : '-'}`,
                                          `${this.comment ? this.comment : '-'}`
                                      ] : [
                                          item.name || '-',
                                          `$${item.amount ? Number(item.amount).toFixed(2) : '-'}`,
                                          `$${item.total_paid ? Number(item.total_paid).toFixed(2) : '-'}`,
                                          item.date_from ? new Date(item.date_from).toLocaleDateString() : '-',
                                          item.note || '-'
                                      ]
                                  ))
                              ]
                          }
                      },
                      {
                          text: '\n\n\n'
                      },
                      {
                          columns: [
                              {
                                  width: '*',
                                  text: [
                                      { text: 'Signature:', bold: true },
                                      { text: '\n\n' },
                                      { text: `Date: ${new Date().toLocaleDateString()}`, bold: true }
                                  ]
                              }
                          ]
                      },
                      {
                          text: '\n\n\n'
                      },
                      {
                          text: 'LABOUR HIRE',
                          style: 'labourHire',
                          margin: [0, 20, 0, 0]
                      },
                      {
                          text: 'PERMANENT RECRUITMENT',
                          style: 'permanentRecruitment'
                      }
                  ],
                  styles: {
                      header: {
                          fontSize: 18,
                          bold: true,
                          alignment: 'center'
                      },
                      contactInfo: {
                          fontSize: 10,
                          color: '#818285'
                      },
                      labourHire: {
                          fontSize: 24,
                          color: '#ECB41F',
                          bold: true
                      },
                      permanentRecruitment: {
                          fontSize: 24,
                          color: '#624891',
                          bold: true
                      }
                  }
              };
          }

          // Generate PDF and convert to base64
          const pdfDocGenerator = pdfMake.createPdf(docDefinition);
          const pdfBase64 = await new Promise<string>((resolve, reject) => {
              try {
              pdfDocGenerator.getBase64((data: any) => {
                  if (data) {
                  resolve(data);
                  } else {
                    reject(new Error('PDF generation returned empty data'));
                  }
              });
              } catch (error) {
                reject(error);
              }
          });

          const deductions = this.dataATD.map((item: any) => ({
              epdiid: 0,
              uid: item.uid,
              pdid: item.pdid,
              amount: item.amount,
              active: "yes",
              date_from: item.date_from,
              date_to: item.date_to,
              limit_fixed: item.limit_fixed,
              amount_taken: this.fixedDeduction ? this.payoutAmount1.toString() : item.amount_taken,
              old_PSID: item.old_PSID,
              name: item.name,
              pcid: item.pcid,
              limit_type: item.limit_type,
              amount_owed: item.amount_owed,
              total_paid: item.amount_owed,
              balance: item.balance,
              liability_account_code: item.liability_account_code,           
              isAstute: item.isAstute,
              note: this.fixedDeduction ? this.comment : item.note,
              isPayOut: item.isPayOut,
              deductionId: item.deductionId,
              batchId: item.batchId,
          }));

          const FileObj = {
              deduction: deductions,
              file: pdfBase64,
              candidatename: this.candidateName,
              employer: this.employeer
          };

          const url = `${environment.apiConfig.uri}/Candidate/SaveATDHistory?fileName=${encodeURIComponent(
              `Authority to Deduct  – ${this.dataATD[0].name?this.dataATD[0].name:"Multi"} - ${this.name}.pdf`)}&receiverEmail=${encodeURIComponent(
              this.email)}&receiverName=${encodeURIComponent(this.name)}&url=${this.redirectUrl}&payOutId=${encodeURIComponent(this.payOutId)}`;
          const response = await this.http.post<any>(url, FileObj).toPromise();
          this.loading = false;
          
          if (response && response.data && response.data.trim() !== '') {
          this.successMessage = 'Please Open below to add your signature to the document.';
          this.docuSignUrl = response.data;
          } else {
            throw new Error('Invalid DocuSign URL received from server');
          }
      } catch (error) {
          this.loading = false;
          this.validationMessage = error instanceof Error ? error.message : 'An error occurred while processing your request. Please try again.';
          this.showSuccessMsg = true;
      }
}

  onClickDownload(item: any) {
    if (!item.fileStream) {
      this.getFileStream(item);
    } else if (item.fileStream && item.fileStream.trim().length > 0) {
      const fileType = this.getFileTypeFromBase64(item.fileStream);
      const link = document.createElement('a');
      link.download = `${item.name || 'file'}.${fileType.extension}`;
      const source = `data:${fileType.mime};base64,${item.fileStream}`;
      link.href = source;
      link.click();
    }
  }

  getFileStream(item: any, view: boolean = false) {
    var url = environment.apiConfig.uri +`/CandidateFiles/GetFileStream/${item.fileId}`;
    this.http.get(url).subscribe(
      (response: any) => {
        this.file = response.data || '';
        item.fileStream = this.file;
        if (view) {
          this.onClickView(item);
        } else {
          this.onClickDownload(item);
        }
      },
      (error) => {
        // console.error('Error fetching file stream:', error);
      }
    );
  }

 onClickView(item: any) {
    if (!item.fileStream) {
      this.getFileStream(item, true);
    } else {
      const fileType = this.getFileTypeFromBase64(item.fileStream);

      if (fileType.mime === 'application/octet-stream') {
        console.warn('Could not determine file type. Opening as generic binary.');
      }
      const byteString = window.atob(item.fileStream);
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const int8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < byteString.length; i++) {
        int8Array[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([int8Array], { type: fileType.mime });
      const fileName = `${item.name || 'file'}.${fileType.extension}`;
      const file = new File([blob], fileName, { type: fileType.mime });
      const link = document.createElement('a');
      link.target = '_blank';
      link.href = window.URL.createObjectURL(file);
      link.click();
    }
  }

   private getFileTypeFromBase64(base64String: string): { mime: string, extension: string } {
    const signatures: { [key: string]: { mime: string, extension: string } } = {
      'R0lGOD': { mime: 'image/gif', extension: 'gif' },
      'iVBOR': { mime: 'image/png', extension: 'png' },
      '/9j/': { mime: 'image/jpeg', extension: 'jpg' },
      'UklGR': { mime: 'image/webp', extension: 'webp' },
      'JVBER': { mime: 'application/pdf', extension: 'pdf' }
    };

    for (const sig in signatures) {
      if (base64String.startsWith(sig)) {
        return signatures[sig];
      }
    }

    return { mime: 'application/octet-stream', extension: 'bin' };
  }

  dataURItoBlob(item: any) {
    const byteString = window.atob(item.fileStream);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], {
      type: `application/pdf`,
    });
    return blob;
  }

  private async loadLogoAsBase64(): Promise<string> {
    return this.loadImageAsBase64(this.brandLogo);
  }

  private async loadImageAsBase64(imagePath: string): Promise<string> {
    return Promise.race([
      this.loadImageAsBase64Internal(imagePath),
      new Promise<string>((_, reject) => 
        setTimeout(() => reject(new Error(`Image loading timeout for ${imagePath}`)), 10000)
      )
    ]);
  }

  private async loadImageAsBase64Internal(imagePath: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.onload = () => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result as string;
          const parts = base64String.split(',');
          if (parts.length < 2) {
            resolve(base64String);
            return;
          }
          const base64Data = parts[1];

          let actualMimeType = '';
          if (base64Data.startsWith('/9j/')) {
            actualMimeType = 'image/jpeg';
          } else if (base64Data.startsWith('iVBOR')) {
            actualMimeType = 'image/png';
          } else if (base64Data.startsWith('R0lGOD')) {
            actualMimeType = 'image/gif';
          } else if (base64Data.startsWith('UklGR')) {
            actualMimeType = 'image/webp';
          } else {
            resolve(base64String);
            return;
          }
          const correctedDataUrl = `data:${actualMimeType};base64,${base64Data}`;
          resolve(correctedDataUrl);
        };
        reader.onerror = reject;

        reader.readAsDataURL(xhr.response);
      };
      xhr.onerror = () => {
        reject(new Error(`Failed to load image at ${imagePath}`));
      };
      xhr.open('GET', imagePath);
      xhr.responseType = 'blob';
      xhr.send();
    });
  }
}
